import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Utility function for smooth scrolling with header offset
export const scrollToElement = (elementId, headerHeight = 80) => {
  const element = document.getElementById(elementId);
  if (element) {
    const elementPosition = element.offsetTop - headerHeight;
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }
};

// Utility function to check if current URL has hash and scroll to it
export const handleHashScroll = (hash, headerHeight = 80) => {
  if (hash) {
    const element = document.querySelector(hash);
    if (element) {
      setTimeout(() => {
        const elementPosition = element.offsetTop - headerHeight;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }, 100);
    }
  }
};

// Component to scroll to top on route change
export const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Only scroll to top if there's no hash in the URL
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return null;
}; 